export const SET_USER = "SET_USER";
export const SET_USER_CONNECTIONS = "SET_USER_CONNECTIONS";

export const POST_USER = "POST_USER";
export const GET_USER = "GET_USER";
export const GET_USER_CONNECTIONS = "GET_USER_CONNECTIONS";